import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { INFO } from '../../theme';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 8px;
`;

const Button = styled.div`
  cursor: pointer;
  color: white;
  background-color: ${INFO};
  text-decoration: none;
  padding: 8px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 8px;
`;

const LinkButton = styled.a`
  cursor: pointer;
  color: white;
  background-color: ${INFO};
  text-decoration: none;
  padding: 8px;
  border-radius: 3px;
  display: inline-block;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 8px;
`;

export const Actions = ({
  filterString,
  componentRef,
  options = [],
  props,
  pointString,
  parcels,
}) => {
  const dispatch = useDispatch();

  return (
    <Row key="download">
      {options.includes('DIRECTIONS') ? (
        <LinkButton
          target="_blank"
          href={`https://www.google.com/maps/dir//'${pointString}'`}
        >
          View Google Map
        </LinkButton>
      ) : null}
      {options.includes('CSV') ? (
        <Button
          onClick={() => {
            dispatch({
              type: 'DOWNLOAD_CSV',
              payload: {
                filterString,
                props,
                parcel_ids: parcels
              },
            });

            dispatch({
              type: 'TRACK',
              payload: {
                name: 'Download CSV',
                filterString,
                props,
              },
            });
          }}
        >
          Download CSV
        </Button>
      ) : null}
      {options.includes('SHAPEFILE') ? (
        <Button
          onClick={() => {
            dispatch({
              type: 'DOWNLOAD_SHAPEFILE',
              payload: {
                props,
                filterString,
                parcel_ids: parcels
              },
            });

            dispatch({
              type: 'TRACK',
              payload: {
                name: 'Download Shapefile',
                props,
                filterString,
              },
            });
          }}
        >
          Download Shapefile
        </Button>
      ) : null}
      {options.includes('PRINT') ? (
        <ReactToPrint
          onBeforePrint={() => {
            dispatch({
              type: 'TRACK',
              payload: {
                name: 'Download PDF',
                filterString,
              },
            });
          }}
          trigger={() => <Button>Print</Button>}
          content={() => componentRef.current}
        />
      ) : null}
    </Row>
  );
};
